export default Object.freeze({
    PROPERTY_INFO: 14,
    TAXES_ASSESMENTS: 15,
    RESTRICTIVE_COVENANTS: 16,
    RECORDED_PLAT: 17,
    LIENS: 18,
    EASEMENTS: 19,
    DEED: 23,
    ADDITIONAL_INFO: 21,
    REVIEW_PTO: 22,
    TITLE_INSURANCE_APPLICATION: 20
});